import "font-awesome/css/font-awesome.min.css";
import React, {
	lazy,
	Suspense,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from "react";
import "react-multi-carousel/lib/styles.css";
import { useDispatch } from "react-redux";
import "../Menu.css";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI } from "../utils/fetchData";

// Lazy load components for better performance
const ReactPlayer = lazy(() => import("react-player/file"));
const Carousel1 = lazy(() => import("./carousel1"));
const Footer = lazy(() => import("./footer"));
const Homecarousel = lazy(() => import("./homecarousel"));
const Navbar = lazy(() => import("./navbar"));
const Talktous = lazy(() => import("./talktous"));

// Constants for brochure URLs
const BROCHURE_URLS = {
	corporate: "./brochures/1-7-25 GLOBAL ACADEMY.pdf",
	courses: "/brochures/2 July 25 Course Cataloque.pdf",
	farmerOrg: "./brochures/FARMER ORGANIZATIONS BROCHURE - 1-7-25.pdf",
	foodProcessors:
		"./brochures/Food Processors & Packhouses BROCHURE - 3-7-25-1.pdf",
	students: "./brochures/STUDENT BROCHURE - 27-6-25.pdf",
	agripreneurs: "./brochures/WOMEN AGRIPRENEURS BROCHURE - 2-7-25.pdf",
	traceAudit: "./brochures/TRACE AUDIT BROC 25-8-25.pdf",
	howtotakeacourse: "./brochures/Final Doc.pdf",
};

// SVG path constants
const ICON_PATHS = {
	leaf: "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z",
	pdf: "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z",
	hands:
		"M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z",
};

// Loading component for lazy loaded components
const LoadingFallback = () => (
	<div
		style={{
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			height: "200px",
			fontSize: "18px",
			color: "#666",
		}}>
		Loading...
	</div>
);

// Memoized brochure item component
const BrochureItem = React.memo(({ url, title, onClick }) => (
	<div
		className="home-section2"
		style={{ cursor: "pointer" }}
		onClick={() => onClick(url)}>
		<div>
			<div className="home-section2-box">
				<div style={{ marginBottom: "25px" }}>
					<div className="home-section2-icon">
						<svg
							aria-hidden="true"
							className="e-font-icon-svg e-far-file-pdf"
							viewBox="0 0 384 512"
							xmlns="http://www.w3.org/2000/svg">
							<path d={ICON_PATHS.pdf}></path>
						</svg>
					</div>
				</div>
				<p className="home-section2-text">{title}</p>
			</div>
		</div>
	</div>
));

// Memoized feature list item component
const FeatureListItem = React.memo(({ text }) => (
	<li style={{ margin: "0px" }}>
		<div className="rc-list">
			<div className="rc-icon">
				<svg
					aria-hidden="true"
					className="e-font-icon-svg e-fas-leaf"
					viewBox="0 0 576 512"
					xmlns="http://www.w3.org/2000/svg">
					<path d={ICON_PATHS.leaf}></path>
				</svg>
			</div>
			<span className="koul-text" dangerouslySetInnerHTML={{ __html: text }} />
		</div>
	</li>
));

// Memoized service card component
const ServiceCard = React.memo(
	({ icon, title, description, imageSrc, imageAlt, linkUrl }) => (
		<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 buttonshow pd-col">
			<div style={{ background: "#fff", borderRadius: "10px" }}>
				<div className="section3-p">
					<div className="section-iconsize">
						<i className={icon}></i>
					</div>
					<div>
						<div className="section3-text1">{title}</div>
						<p className="section3-text2 section3-b1">{description}</p>
					</div>
				</div>
				<div style={{ position: "relative" }}>
					<div className="section3-image">
						<img
							style={{ width: "100%" }}
							src={imageSrc}
							alt={imageAlt}
							loading="lazy"
						/>
					</div>
					<div
						className="section3-button section3-display"
						style={{
							position: "absolute",
							bottom: "0px",
							width: "100%",
						}}>
						<a
							style={{
								color: "#fff",
								justifyContent: "space-between",
								alignItems: "center",
							}}
							href={linkUrl}
							target=""
							rel="">
							Read More{" "}
							<i
								style={{ alignSelf: "right" }}
								className="fa fa-chevron-right"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
	)
);

const Home = () => {
	const dispatch = useDispatch();
	const [skills, setSkills] = useState("");

	// Memoized brochure click handler
	const handleBrochureClick = useCallback((url) => {
		window.open(url, "_blank");
	}, []);

	// Fetch skill development records
	useEffect(() => {
		const fetchSkills = async () => {
			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				const res = await getDataAPI(`getTotalParticipants`);
				setSkills(res.data.totalParticipants || []);
			} catch (err) {
				console.error("Error fetching skill development records:", err);
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch skill development records" },
				});
			} finally {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};

		fetchSkills();
	}, [dispatch]);

	// Memoized service data
	const serviceData = useMemo(
		() => [
			{
				icon: "fa fa-book",
				title: "Courses",
				description:
					"Skill Development Courses on Global Food Safety and Sustainability Standards to strengthen your expertise.",
				imageSrc: "../images/Coursesbanner.jpg",
				imageAlt: "Courses banner",
				linkUrl: "./courses/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af",
			},
			{
				icon: "fa fa-folder-open",
				title: "Digital Library",
				description:
					"Collection of videos on good agricultural practices in the implementation of On Farm Production related Standards.",
				imageSrc: "../images/digitalbanner.jpg",
				imageAlt: "Digital library banner",
				linkUrl: "/digitallibrary/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af",
			},
			{
				icon: "fa fa-gears",
				title: "Regulatory Compliances",
				description:
					"Ensuring compliance at every stage of the food chain is essential for food safety, quality, and market access.",
				imageSrc: "../images/compliancebanner.jpg",
				imageAlt: "Compliance banner",
				linkUrl: "./regulatorycompliances",
			},
		],
		[]
	);

	// Memoized brochure data
	// const brochureData = useMemo(
	// 	() => [
	// 		{ url: BROCHURE_URLS.corporate, title: "Corporate Brouchure" },
	// 		{ url: BROCHURE_URLS.courses, title: "Courses Catalogues" },
	// 		{ url: BROCHURE_URLS.traceAudit, title: "Trace Audit" },
	// 		{ url: BROCHURE_URLS.farmerOrg, title: "Farmer Organization" },
	// 		{
	// 			url: BROCHURE_URLS.foodProcessors,
	// 			title: "Food Processors and Pack House",
	// 		},
	// 		{ url: BROCHURE_URLS.students, title: "Students" },
	// 		{ url: BROCHURE_URLS.agripreneurs, title: "Agripreneurs" },
	// 	],
	// 	[]
	// );

	const brochureData = useMemo(
		() => [
			{ url: BROCHURE_URLS.corporate, title: "Corporate Brouchure" },
			{ url: BROCHURE_URLS.courses, title: "Courses Catalogues" },
			{ url: BROCHURE_URLS.traceAudit, title: "Trace Audit" },
			{ url: BROCHURE_URLS.farmerOrg, title: "Farmer Organization" },
			{
				url: BROCHURE_URLS.foodProcessors,
				title: "Food Processors and Pack House",
			},
			{ url: BROCHURE_URLS.students, title: "Students" },
			{ url: BROCHURE_URLS.agripreneurs, title: "Agripreneurs" },
		],
		[]
	);

	// Memoized feature list data
	const featureListData = useMemo(
		() => [
			"<b>Self-paced and expert-led training</b> – Learn at your own pace or join live sessions led by standards experts.",
			"<b>Model Farm</b> – See best practices in action and you can replicate success on your own farm.",
			"<b>TraceAudit™</b>– A digital compliance tool that  empowers food businesses and farmer organizations to achieve global food safety standards compliance, digitize records, demonstrate transparency, and unlock premium markets by earning the trust of buyers and certifiers.",
		],
		[]
	);

	return (
		<>
			<Suspense fallback={<LoadingFallback />}>
				<Navbar />
			</Suspense>
			<div style={{ backgroundColor: "#ffffff" }}>
				<div>
					<Suspense fallback={<LoadingFallback />}>
						<Homecarousel />
					</Suspense>
				</div>
				<div className="container pt-pb1">
					<div className="row">
						<div className="col-12 col-sm-12 col-md-8 mb-4 mb-md-0">
							<h6
								className="section1-tittle1"
								style={{ fontSize: "18px", fontWeight: "700" }}>
								WHO WE ARE
							</h6>
							<h2
								className="section1-tittle2"
								style={{
									fontSize: "28px",
									fontWeight: 700,
									letterSpacing: "0.5px",
									lineHeight: "28px",
								}}>
								Global Academy for Food Safety and Sustainability Standards
							</h2>
							<p
								className="section1-tittle3"
								style={{
									fontFamily: "Rubik, sans-serif",
									fontSize: "16px",
									fontWeight: 400,
									letterSpacing: "0.5px",
									lineHeight: "26px",
									color: "rgb(0, 0, 0)",
								}}>
								Leading India's rise as a global powerhouse in safe,
								sustainable, and certified food systems.
								<br />
								<b>About the Global Academy</b>
								<br />
								India's first AI-powered learning and compliance platform for
								the agri-food sector — designed to empower farmer organizations,
								food processors, exporters, and institutions to meet global food
								safety and sustainability standards with confidence.
								<br />
								<b>Here's how we make it happen:</b>
								<ul
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "10px",
										padding: "20px",
									}}>
									{featureListData.map((text, index) => (
										<FeatureListItem key={index} text={text} />
									))}
								</ul>
								<b>The Impact:</b>
								<br />
								Our solutions drive{" "}
								<b>
									income growth, premium market access, climate resilience,
								</b>{" "}
								and <b>widespread standards adoption</b> — making your business
								ready to compete on the global stage.
							</p>
						</div>
						<div className="col-12 col-sm-12 col-md-4">
							<div style={{ display: "flex", flexDirection: "column" }}>
								<div>
									<Suspense fallback={<LoadingFallback />}>
										<ReactPlayer
											url={`${
												process.env.REACT_APP_HOST === "local"
													? "http://localhost:3000"
													: window.location.origin
											}/images/Global%20Academy_1.mp4`}
											playing={false}
											muted={false}
											controls={true}
											width="100%"
											height="260px"
											style={{ backgroundColor: "black" }}
											config={{
												file: {
													attributes: {
														crossOrigin: "anonymous",
													},
												},
											}}
										/>
									</Suspense>
								</div>
								<div
									style={{
										backgroundColor: "#BBE4A3",
										marginTop: "20px",
									}}>
									<a href="./skilldevelopement">
										<div
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												flexDirection: "column",
												height: "fit-content",
											}}>
											<div style={{ padding: "15px", marginBottom: "15px" }}>
												<div
													style={{
														fill: "#006436",
														height: "35px",
														width: "50px",
													}}>
													<svg
														aria-hidden="true"
														className="elementskit-funfact-icon e-font-icon-svg e-fas-hands"
														viewBox="0 0 640 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d={ICON_PATHS.hands}></path>
													</svg>
												</div>
											</div>
											<p
												style={{
													color: "rgb(15, 53, 103)",
													cursor: "pointer",
													display: "inline",
													fontFamily: "Rubik, sans-serif",
													fontSize: "28px",
													fontWeight: 900,
													height: "auto",
													letterSpacing: "0.5px",
													lineHeight: "28px",
												}}>
												{skills}
											</p>
											<p
												style={{
													color: "rgb(15, 53, 103)",
													cursor: "pointer",
													display: "block",
													fontFamily: "Rajdhani, sans-serif",
													fontSize: "25px",
													fontWeight: 900,
													letterSpacing: "0.5px",
													lineHeight: "44px",
													textAlign: "center",
													marginBottom: "0px",
												}}>
												Global Academy trained Personnel For Food Safety
												Standards.
											</p>
										</div>
									</a>
								</div>
							</div>
						</div>
						<div className="d-flex justify-content-center">
							<div className="section1-button">
								<a
									href="/keyobjectives"
									target="_self"
									rel="nofollow"
									className="link-anime v2">
									Read More
								</a>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="container pt-pb">
					<div className="home-section2-flex">
						{brochureData.map((brochure, index) => (
							<BrochureItem
								key={index}
								url={brochure.url}
								title={brochure.title}
								onClick={handleBrochureClick}
							/>
						))}
					</div>
				</div> */}

				{/* ==================== THREE BROCHURE BLOCKS – EQUAL HEIGHT ==================== */}
				<div className="container pb-5">
					<div className="row justify-content-center align-items-stretch g-4">
						{/* BLOCK 1: Catalogues */}
						<div className="col-12 col-md-4 d-flex">
							<div
								className="text-center p-4 d-flex flex-column justify-content-center align-items-center flex-fill"
								style={{
									backgroundColor: "rgb(187, 228, 163)",
									borderRadius: "0px",
									boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
									width: "100%",
									minHeight: "100%", // ensures equal height
								}}>
								<div style={{ marginBottom: "20px" }}>
									<svg
										aria-hidden="true"
										viewBox="0 0 384 512"
										width="36"
										height="36">
										<path d={ICON_PATHS.pdf} fill="#2d947a"></path>
									</svg>
								</div>
								<p
									className="mb-0"
									style={{
										fontSize: "16px",
										color: "rgb(15, 53, 103)",
										fontWeight: "500",
									}}>
									<a
										href={BROCHURE_URLS.courses}
										target="_blank"
										rel="noopener noreferrer"
										style={{ textDecoration: "none", color: "inherit" }}
										onClick={(e) => {
											e.preventDefault();
											handleBrochureClick(BROCHURE_URLS.courses);
										}}>
										Courses Catalogues
									</a>
								</p>
							</div>
						</div>

						{/* BLOCK 2: Brochures (List) */}
						<div className="col-12 col-md-4 d-flex">
							<div
								className="p-4 d-flex flex-column justify-content-center flex-fill"
								style={{
									backgroundColor: "rgb(187, 228, 163)",
									borderRadius: "0px",
									boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
									width: "100%",
									minHeight: "100%",
								}}>
								<h5
									className="text-center mb-3"
									style={{
										fontSize: "16px",
										fontWeight: 700,
										color: "rgb(15, 53, 103)",
										margin: 0,
									}}>
									Brochures
								</h5>

								<ul
									className="list-unstyled m-0 d-flex flex-column justify-content-center flex-grow-1"
									style={{ fontSize: "16px", lineHeight: "1.6" }}>
									{[
										{
											url: BROCHURE_URLS.corporate,
											title: "Corporate Brochure",
										},
										{ url: BROCHURE_URLS.traceAudit, title: "Trace Audit" },
										{
											url: BROCHURE_URLS.farmerOrg,
											title: "Farmer Organization",
										},
										{
											url: BROCHURE_URLS.foodProcessors,
											title: "Food Processors & Pack House",
										},
										{ url: BROCHURE_URLS.students, title: "Students" },
										{ url: BROCHURE_URLS.agripreneurs, title: "Agripreneurs" },
									].map((b, i) => (
										<li key={i} className="d-flex align-items-center mb-2">
											<svg
												aria-hidden="true"
												viewBox="0 0 384 512"
												width="18"
												height="18"
												className="me-2">
												<path d={ICON_PATHS.pdf} fill="#2d947a"></path>
											</svg>
											<a
												href={b.url}
												target="_blank"
												rel="noopener noreferrer"
												style={{
													textDecoration: "none",
													color: "rgb(15, 53, 103)",
													fontWeight: "500",
													fontSize: "16px",
												}}
												onClick={(e) => {
													e.preventDefault();
													handleBrochureClick(b.url);
												}}>
												{b.title}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>

						{/* BLOCK 3: How to Take Online Course */}
						<div className="col-12 col-md-4 d-flex">
							<div
								className="text-center p-4 d-flex flex-column justify-content-center align-items-center flex-fill"
								style={{
									backgroundColor: "rgb(187, 228, 163)",
									borderRadius: "0px",
									boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
									width: "100%",
									minHeight: "100%",
								}}>
								<div style={{ marginBottom: "20px" }}>
									<svg
										aria-hidden="true"
										viewBox="0 0 384 512"
										width="36"
										height="36">
										<path d={ICON_PATHS.pdf} fill="#2d947a"></path>
									</svg>
								</div>
								<p
									className="mb-0"
									style={{
										fontSize: "16px",
										color: "rgb(15, 53, 103)",
										fontWeight: "500",
									}}>
									<a
										href={BROCHURE_URLS.howtotakeacourse}
										style={{ textDecoration: "none", color: "inherit" }}
										onClick={(e) => {
											e.preventDefault();
											handleBrochureClick(BROCHURE_URLS.howtotakeacourse);
										}}>
										How To Take A Course Online
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
				{/* ==================== END THREE BLOCKS ==================== */}

				<div className="pt-pb" style={{ backgroundColor: "#BBE4A3" }}>
					<div className="container">
						<div className="row section3-margin fadeInUp-animation homecard-flex">
							{serviceData.map((service, index) => (
								<ServiceCard
									key={index}
									icon={service.icon}
									title={service.title}
									description={service.description}
									imageSrc={service.imageSrc}
									imageAlt={service.imageAlt}
									linkUrl={service.linkUrl}
								/>
							))}
						</div>
					</div>
				</div>
				<div className="container pt-pb1">
					<div>
						<h6 className="section1-tittle1">CLIENTS REVIEW</h6>
					</div>
				</div>
				<div style={{ paddingBottom: "100px" }}>
					<Suspense fallback={<LoadingFallback />}>
						<Carousel1 />
					</Suspense>
				</div>
				<Suspense fallback={<LoadingFallback />}>
					<Talktous />
				</Suspense>
			</div>
			<Suspense fallback={<LoadingFallback />}>
				<Footer />
			</Suspense>
		</>
	);
};

export default Home;
